<template>
    <div id="ButtonSection">
      <v-layout wrap class="jc-c">
        <v-btn
          fixed
          bottom
          @click="$emit('open-application-dialog', true)"
        >
          지금 혜택 받고 신청하기
        </v-btn>
      </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ButtonSection',
}
</script>
<style lang="scss" scoped>
  #ButtonSection {
    padding-left: 4.498vh;
    padding-right: 4.498vh;
    button {
      width: 84.4%;
      height: 3.75rem;
      // border-radius: 30px;
      box-shadow: 0 8px 16px 0 rgba(51, 51, 51, 0.12);
      background-color: #00ADE5;
      font-size: 1.13rem;
      font-weight: 600;
      letter-spacing: -0.66px;
      color: #ffffff;
      margin-bottom: 2vh;
    }
  }
</style>
